import React, {useEffect, useRef, useState} from 'react'
import {useTranslation} from "react-i18next";
import {SUPPORTED_LANGUAGES, SupportedLanguage, getCurrentLanguage} from "../../i18n/i18n";
import './LanguageSwitcher.scss'

import flagFr from '../../Assets/Flags/fr.svg'
import flagGb from '../../Assets/Flags/gb.svg'
import flagIt from '../../Assets/Flags/it.svg'
import flagEs from '../../Assets/Flags/es.svg'
import flagCn from '../../Assets/Flags/cn.svg'

const FLAGS: Record<SupportedLanguage, string> = {
    fr: flagFr,
    en: flagGb,
    it: flagIt,
    es: flagEs,
    zh: flagCn,
}

const NAMES: Record<SupportedLanguage, string> = {
    fr: 'Français',
    en: 'English',
    it: 'Italiano',
    es: 'Español',
    zh: '中文',
}

const LanguageSwitcher: React.FC = () => {
    const {i18n} = useTranslation()
    const currentLang = getCurrentLanguage()
    const [isOpen, setIsOpen] = useState(false)
    const containerRef = useRef<HTMLDivElement>(null)

    useEffect(() => {
        if (!isOpen) {
            return
        }

        const handleClickOutside = (event: MouseEvent) => {
            if (containerRef.current && !containerRef.current.contains(event.target as Node)) {
                setIsOpen(false)
            }
        }

        document.addEventListener('mousedown', handleClickOutside)
        return () => document.removeEventListener('mousedown', handleClickOutside)
    }, [isOpen])

    const selectLanguage = (lng: SupportedLanguage) => {
        void i18n.changeLanguage(lng)
        setIsOpen(false)
    }

    return (
        <div className="languageSwitcher" ref={containerRef}>
            <button
                type="button"
                className="languageSwitcher--toggle"
                onClick={() => setIsOpen(prev => !prev)}
                aria-haspopup="listbox"
                aria-expanded={isOpen}
                aria-label={NAMES[currentLang]}
            >
                <img src={FLAGS[currentLang]} alt={NAMES[currentLang]} className="languageSwitcher--flag"/>
            </button>
            {isOpen && (
                <ul className="languageSwitcher--menu" role="listbox">
                    {SUPPORTED_LANGUAGES.map(lng => (
                        <li key={lng} role="option" aria-selected={currentLang === lng}>
                            <button
                                type="button"
                                className={`languageSwitcher--item ${currentLang === lng ? 'active' : ''}`}
                                onClick={() => selectLanguage(lng)}
                                aria-label={NAMES[lng]}
                            >
                                <img src={FLAGS[lng]} alt={NAMES[lng]} className="languageSwitcher--flag"/>
                            </button>
                        </li>
                    ))}
                </ul>
            )}
        </div>
    )
}

export default LanguageSwitcher
